// extracted by mini-css-extract-plugin
export var active = "_i3-2";
export var recordingDot = "_i3-1";
export var recordingIndicator = "_i3-0";